import { MAIN_APP_URL } from 'src/config-global';

export const redirectToMainApp = () => {
  if (MAIN_APP_URL) {
    window.location.href = MAIN_APP_URL;
  }
};

export const replaceUrlWithoutParam = (paramKey) => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete(paramKey);
    window.history.replaceState({}, document.title, url.toString());
  } catch (e) {
    // noop
  }
};
